<template>
  <div class="home mt-2">
    <entity-header
      title="Keywords"
      :show-filters="true"
      :show-export="true"
      @export="getKeywordsExcel"
      :show-new="true"
      new-label="Nueva Keyword"
      new-tooltip="Nueva Keyword"
      :show-status-filter="true"
      :status.sync="keyword_activo"
      :has-active-filters="hasActiveFilters"
      @status-change="keywordsBuscar"
      @search="keywordsBuscar"
      @new="showEdit({}, 'add')"
    >
      <template #filters>
        <div class="form-group col mb-2">
          <label class="font-weight-bold small text-muted mb-1" for="keyword_select">Buscar por Keyword</label>
          <input
            type="text"
            class="form-control"
            id="keyword_select"
            placeholder="Filtrar por keyword..."
            v-model="keyword_sel"
            @keyup.enter="keywordsBuscar"
            aria-label="Keyword"
          />
        </div>
      </template>
    </entity-header>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>


        
    <data-table
      v-if="keywordsBusqueda && keywordsBusqueda.data.length"
      :columns="columns"
      :data="keywordsBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_keyword"
      @sort="orderByfield"
    >
      <template #cell-integrador="{ item, value }">
        {{ value || getIntegradorName(item.id_integrador) }}
      </template>
      <template #actions="{ item }">
        <table-actions
          :item="item"
          :show-edit="false"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador
      v-if="keywordsBusqueda && keywordsBusqueda.pages"
      :pages="keywordsBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <empty-state
      :show="Boolean(post && keywordsBusqueda && keywordsBusqueda.data && !keywordsBusqueda.data.length)"
      message="No se encontraron keywords que coincidan con la búsqueda."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal CRUD Estandarizado -->
    <crud-modal
      :show="showModal"
      :title="modalTitle"
      :is-toggle="operation == 'toggle'"
      :show-save="operation == 'add' || operation == 'toggle'"
      :save-text="modalSaveText"
      :save-variant="operation == 'toggle' ? (editData && editData.activo == 1 ? 'warning' : 'success') : 'primary'"
      @close="closeModal"
      @save="onModalSave"
    >

      <form v-if="editData && operation == 'add'" @submit.prevent="onModalSave">
        <div class="alert alert-info d-flex align-items-center mb-3" role="alert">
          <i class="bi bi-info-circle-fill mr-2" style="font-size: 1.25rem; flex-shrink: 0;"></i>
          <div>
            <strong>Información:</strong> Para altas por SMS, usar solo letras y números. <strong>No utilizar guiones bajos</strong>.
          </div>
        </div>

        <div v-if="isTodosIntegrador" class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Integrador <span class="text-danger">*</span></label>
          <select class="form-control" name="id_integrador" v-model="editData.id_integrador" required>
            <option :value="null">Seleccione un integrador...</option>
            <option
              v-for="item in integradoresList"
              :key="item.id_integrador || item.id"
              :value="item.id_integrador || item.id"
            >
              {{ item.integrador }}
            </option>
          </select>
          <small class="form-text text-muted">Seleccione el integrador para esta keyword.</small>
        </div>
        <div v-else class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Integrador</label>
          <input
            type="text"
            class="form-control"
            :value="getIntegradorName(id_integrador_sel)"
            disabled
            readonly
          />
          <small class="form-text text-muted">Integrador seleccionado para la nueva keyword (no editable).</small>
        </div>

        <div class="form-group">
          <label class="font-weight-bold small text-muted mb-1">Keyword <span class="text-danger">*</span></label>
          <input
            class="form-control"
            name="keyword"
            :class="{ 'is-invalid': editData && editData.keyword && !/^[0-9a-z_]+$/.test(editData.keyword) }"
            type="text"
            placeholder="Ej: clubjuegos"
            v-model="editData.keyword"
            maxlength="50"
            @input="(e) => (editData.keyword = e.target.value.toLowerCase().slice(0, 50))"
          />
          <small class="form-text text-muted">Palabra clave en minúsculas sin espacios solo letras, números y guiones bajos (máx. 50 caracteres).</small>
          <small class="text-danger d-block mt-1" v-if="editData && editData.keyword && /\s/.test(editData.keyword)">
            <i class="bi bi-exclamation-triangle"></i> No se permiten espacios en la keyword.
          </small>
          <small class="text-danger d-block mt-1" v-else-if="editData && editData.keyword && !/^[0-9a-z_]+$/.test(editData.keyword)">
            <i class="bi bi-exclamation-triangle"></i> Solo se permiten letras minúsculas (a-z), números (0-9) y guión bajo (_).
          </small>
        </div>

        <div v-if="errors" class="alert alert-danger" role="alert">
          {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
          <ul v-if="errorsD && errorsD.length" class="mb-0 mt-1 pl-3">
            <li v-for="errordetalle of errorsD" :key="errordetalle">
              {{ errordetalle }}
            </li>
          </ul>
        </div>
      </form>
    </crud-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import EntityHeader from "./utiles/EntityHeader.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import CrudModal from "./utiles/CrudModal.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "Keywords",
  mixins: [tableSortMixin],
  data() {
    return {
      columns: [
        { label: "Id", field: "id_keyword", width: "80" },
        { label: "Integrador", field: "integrador" },
        { label: "Keyword", field: "keyword" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      success: null,
      error: null,
      id_integrador_sel: localStorage.getItem("integrador"),
      keyword_activo: "",
      keyword_sel: "",
      keywordsBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      errorsD: [],
      pages: null,
    };
  },
  components: {
    EntityHeader,
    DataTable,
    Paginador,
    TableActions,
    EmptyState,
    CrudModal,
  },
  created() {
    this.getKeywordsBusqueda();
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    modalTitle() {
      if (this.operation === "add") return "Nueva Keyword";
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1
          ? "Suspender Keyword"
          : "Reactivar Keyword";
      }
      return "";
    },
    modalSaveText() {
      if (this.operation === "toggle") {
        return this.editData && this.editData.activo == 1 ? "Suspender" : "Reactivar";
      }
      return "Guardar";
    },
    hasActiveFilters() {
      return (
        Boolean(this.keyword_sel) ||
        (this.keyword_activo !== null && this.keyword_activo !== undefined && this.keyword_activo !== "")
      );
    },

    isTodosIntegrador() {
      return !this.id_integrador_sel || this.id_integrador_sel === "todos";
    },

    integradoresList() {
      let list = [];
      if (this.integradores && this.integradores.data && this.integradores.data.length > 0) {
        list = [...this.integradores.data];
      } else if (this.user && this.user.integradores && Array.isArray(this.user.integradores)) {
        list = [...this.user.integradores];
      }
      return list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
    },
  },

  watch: {
    "$store.state.integrador.integrador"(newVal) {
      this.id_integrador_sel = newVal;
      this.page = 1;
      this.getKeywordsBusqueda();
    },
  },
  methods: {
    getIntegradorName(id) {
      if (!id) return "";
      const list = this.integradores && this.integradores.data ? this.integradores.data : (Array.isArray(this.integradores) ? this.integradores : []);
      const found = list.find((i) => String(i.id_integrador || i.id) === String(id));
      return found ? found.integrador : id;
    },
    onModalSave() {
      if (this.operation === "add") {
        this.agregarKeyword();
      } else if (this.operation === "toggle") {
        this.toggleStatus();
      }
    },
    keywordsBuscar: function () {
      this.changePage(1);
    },
    changePage: function (page) {
      this.page = page;
      this.getKeywordsBusqueda(false);
    },
    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getKeywordsBusqueda(false);
    },
    getKeywordsBusqueda: function (hideResult = true) {
      if (hideResult) this.keywordsBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/busqueda", {
          page: this.page,
          id_integrador: this.id_integrador_sel,
          keyword: this.keyword_sel,
          activo: this.keyword_activo,
          order_by: {
            field: this.orderByField,
            order: this.orderByDirection,
          },
        })
        .then((response) => {
          this.keywordsBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las keywords",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

  getKeywordsExcel: function () {
    startAsyncExport("keyword", {
      id_integrador: this.id_integrador_sel,
      order_by: {
        field: this.orderByField,
        order: this.orderByDirection,
      },
    }, "Keywords");
  },
    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      const targetActivo = 1 - Number(this.editData.activo || 0);
      const payload = {
        ...this.editData,
        activo: targetActivo,
      };
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/update", payload)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Keywords actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getKeywordsBusqueda();
        });
    },
    showEdit: function (item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      if (operation === "add") {
        this.editData.id_integrador = this.isTodosIntegrador
          ? null
          : parseInt(this.id_integrador_sel);
      }
      this.showModal = true;
      this.operation = operation;
    },
    agregarKeyword: function () {
      this.errors = null;
      this.errorsD = [];
      if (this.editData.keyword && !/^[0-9a-z_]+$/.test(this.editData.keyword)) {
        this.errors = "La Keyword no cumple con el formato permitido: solo se permiten letras minúsculas (a-z), números (0-9) y guiones bajos (_), sin espacios ni caracteres especiales.";
        return;
      }
      if (!this.editData.id_integrador || this.editData.id_integrador === "todos") {
        if (!this.isTodosIntegrador) {
          this.editData.id_integrador = parseInt(this.id_integrador_sel);
        } else {
          this.errors = "Debe seleccionar un integrador para la nueva keyword";
          return;
        }
      }
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/new", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.closeModal();
            Swal.fire({
              title: "Bien!",
              text: "Keywords creada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
            this.errorsD = (e.response.data.errors && e.response.data.errors.keyword) ? e.response.data.errors.keyword : [];
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getKeywordsBusqueda();
        });
    },
    closeModal() {
      this.showModal = false;
      this.operation = null;
      this.editData = null;
      this.errors = null;
    },
  },
};
</script>
<style scoped></style>